import {Alert, Button, Drawer, Flex, Modal, Paper, Select, Space, Text} from "@mantine/core";
import PreviewModal from "./PreviewModal";
import {IconChevronDown, IconCircleNumber1} from "@tabler/icons-react";
import classes from "../css/Results.module.css";
import {DateInput} from "@mantine/dates";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {useDisclosure} from "@mantine/hooks";
import {setCustomer, setExportLoading} from "../redux/actions";
import csvtojson from "csvtojson";
import {download, generateCsv, mkConfig} from "export-to-csv";
import {useTranslation} from "react-i18next";

export default function ExportDrawer({isMobile, isOpen, closeDrawer}){
    const [disabled, setDisabled] = useState(false);
    const [opened, { open, close }] = useDisclosure(false);
    const [previewData, setPreviewData] = useState([{"emptyData":true}])
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const customerObject = JSON.parse(localStorage.getItem("customers"))
    const [customers,setCustomers] = useState(Object.keys(customerObject))
    const [isMultiCustomer, setIsMultiCustomer] = useState(customers.length>1)

    const handleSetCustomer = (newCustomer) => {
        //localStorage.setItem("currentCustomer", newCustomer);
        dispatch(setCustomer(newCustomer))
    }
    const currentCustomer = useSelector(state => state.customer.currentCustomer);

    const controllerRef = useRef(null);
    //fetch function with params for start, end, and user
    const getCSV = async (uuid, start, end, isExport) => {
        dispatch(setExportLoading(true))
        let url = "/api/v1/Activation/Export/"

        controllerRef.current = new AbortController();
        const { signal } = controllerRef.current;

        if(uuid){
            url += `?customer_uuid=${uuid}`
            if(start){
                const formatStart = new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }).format(start);
                url+=`&startDate=${formatStart}`
            }

            if(end){
                const endPlusOne = new Date(end);
                endPlusOne.setDate(endPlusOne.getDate() + 1); //add one to the end date so that it is inclusive vs excluded
                const formatEnd = new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }).format(endPlusOne);
                url+=`&endDate=${formatEnd}`
            }
        }else{ //for single customers
            if(start){
                const formatStart = new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }).format(start);
                url+=`?startDate=${formatStart}`
            }

            if(end){
                const formatEnd = new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }).format(end);
                url+=`&endDate=${formatEnd}`
            }
        }

        fetch (url, {
            method: "GET",
            credentials: 'include',
            signal //passing signal to abort export on drawer close
        }).then(response => response.text())
            .then(result => {
                csvtojson()
                    .fromString(result)
                    .then(async jsonArray => {
                        const withFormattedDateAndCustomer = jsonArray.map(item => { //add consistent date and customer
                            let date = new Date(`${item['ActivationTime(UTC)']} UTC`)
                            let timeZoneAbbreviation = new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2];
                            let localDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString()} ${timeZoneAbbreviation}`;
                            delete item['ActivationTime(UTC)']
                            return {...item, CustomerName: currentCustomer, ActivationTime: localDate}; //not sure if there is existing customer field to worry about? may need API call so customer field is not ""??
                        });
                        if (isExport) {
                            if(withFormattedDateAndCustomer.length === 0){ //if with formatted is empty
                                result = "EndpointSerialNumber,EncoderSerialNumber,EndpointStatus,NetworkStatus,MeterStatus,LastRegisterRead,CustomerName,ActivationTime" //This is the hardcoded output of an empty export, will need to be changed if export values change
                                download(csvConfig)(result)
                                dispatch(setExportLoading(false))
                            }else{
                                const formattedCSV = generateCsv(csvConfig)(withFormattedDateAndCustomer)
                                download(csvConfig)(formattedCSV)
                                dispatch(setExportLoading(false))
                            }

                        } else {
                            setPreviewData(withFormattedDateAndCustomer)
                            open()
                            dispatch(setExportLoading(false))
                        }

                    })
            }).catch((error)=>{
            dispatch(setExportLoading(false))
            console.log(error)
            //alert("Network Error, please try again!")
        }).finally(()=>{
            closeConfirmation()
        })
    }
    const csvConfig = mkConfig({useKeysAsHeaders: true, filename: "activations"});
    const exportToCSV = async () => {
        let uuid = customerObject[currentCustomer]
        await getCSV(uuid, startDate, endDate, true)
    }

    const preview = async () => {
        let uuid = customerObject[currentCustomer]
        await getCSV(uuid, startDate, endDate, false)
    }

    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    useEffect(() => {
        if(!startDate != !endDate){ //if only one date is selected
            setDisabled(true)
        }else{
            setDisabled(false)
        }
    }, [startDate, endDate]);

    const isExportLoading = useSelector(state => state.loading.isExportLoading);
    const closeAndAbort = () => {
        if(isExportLoading){ //if ongoing export, open confirmation
            openConfirmation()
        }else{
            leaveExport()
        }
    }

    const leaveExport = () => {
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
        closeConfirmation()
        closeDrawer()
    }

    const [openedConfirmation, { open: openConfirmation, close: closeConfirmation }] = useDisclosure(false);

    return (<div>{ isMobile ? (
            <Modal opened={isOpen} onClose={closeAndAbort} withCloseButton={true} removeScrollProps={{enabled: false}}
                   overlayProps={{backgroundOpacity: 0.5, blur: 4}} radius="sm"
                   title={<div style={{textAlign: "center", fontWeight: 'bold', width: '100%'}}>{t("Export")}</div>}>
                <Modal opened={openedConfirmation} onClose={closeConfirmation} size="md" title={t("Cancel Ongoing Export/Preview?")}>
                    {t("Leaving will cancel the ongoing export or preview")}.
                    <Space h="sm"/>
                    <Flex
                        direction="row"
                        gap="sm"
                        justify="center"
                    >
                        <Button color="red" onClick={leaveExport}>{t("Cancel")}</Button>
                        <Button color="gray" variant="outline" onClick={closeConfirmation}>{t("Not now")}</Button>
                    </Flex>
                </Modal>
                <PreviewModal size="100%" isOpen={opened} onClose={close} data={previewData}></PreviewModal>
                <Paper
                    style={{
                        width: '100%', // Full width on small screens
                        maxWidth: '1200px', // Limit width on larger screens
                        margin: '0 auto', // Center horizontally
                    }}
                    p="xl"
                    bg="var(--mantine-color-white)">
                    <Flex direction="column" gap="lg">
                        {isMultiCustomer ? (<div><Select
                                rightSection={<IconChevronDown/>}
                                label={t("Customer Name")}
                                size="md"
                                data={customers}
                                value={currentCustomer}
                                onChange={handleSetCustomer}
                                allowDeselect={false}
                                withScrollArea={false}
                                styles={{ dropdown: { maxHeight: 200, overflowY: 'auto' }, input: {textOverflow: 'ellipsis'}}}
                            />
                            </div>
                        ) : (<div>
                            <Select
                                className={classes.noClick}
                                size="md"
                                label={t("Customer Name")}
                                data={customers}
                                value={currentCustomer}
                                rightSection={<IconCircleNumber1 color="white"/>}
                                styles={{input: {textOverflow: 'ellipsis'}}}
                            />
                        </div>)
                        }
                        <DateInput
                            clearable
                            size="md"
                            label={t("Start Date")}
                            value={startDate}
                            onChange={setStartDate}
                            maxDate={endDate}
                        />
                        <DateInput
                            clearable
                            size="md"
                            label={t("End Date")}
                            value={endDate}
                            onChange={setEndDate}
                            minDate={startDate}
                        />
                        {disabled ?
                            <Text align="center" style={{color: "red"}}>❗{t("select-two-dates-message")}</Text> :
                            <Fragment></Fragment>}
                        <Alert align="center">{t("no-date-message")}</Alert>
                        <Button size="md" disabled={disabled} onClick={preview}>{t("Preview")}</Button>
                        <Button size="md" color="red" disabled={disabled} onClick={exportToCSV}>{t("Export to CSV")}</Button>
                    </Flex>

                </Paper>
            </Modal>):(<Drawer offset={8} position="right" radius="sm"
                               opened={isOpen} onClose={closeAndAbort} removeScrollProps={{enabled: false}}
                               title={<span style={{fontWeight: 'bold'}}>{t("Export")}</span>}>
        <Modal opened={openedConfirmation} onClose={closeConfirmation} size="md" title={t("Cancel Ongoing Export/Preview?")}>
            {t("Leaving will cancel the ongoing export or preview")}.
            <Space h="sm"/>
            <Flex
                direction="row"
                gap="sm"
                justify="flex-end"
            >
                <Button color="red" onClick={leaveExport}>{t("Cancel")}</Button>
                <Button color="gray" variant="outline" onClick={closeConfirmation}>{t("Not now")}</Button>
            </Flex>
        </Modal>
        <Flex
            direction="column"
            gap="sm"
        >
            {isMultiCustomer ? (<><Select
                    label={t("Customer Name")}
                    size="md"
                    data={customers}
                    value={currentCustomer}
                    onChange={handleSetCustomer}
                    style={{
                        border: 'none',
                        boxShadow: 'none' // This removes the outline and box shadow
                    }}
                    outline={false}
                    allowDeselect={false}
                    withScrollArea={false}
                    rightSection={<IconChevronDown/>}
                    styles={{ dropdown: { maxHeight: 200, overflowY: 'auto' }, input: {textOverflow: 'ellipsis'}}}
                />
                    <Space w="xl"/></>
            ) : (<div><Select
                className={classes.noClick}
                size="md"
                label={t("Customer Name")}
                data={customers}
                value={currentCustomer}
                styles={{input: {textOverflow: 'ellipsis'}}}
                rightSection={<IconCircleNumber1 color="white"/>}
            /></div>)}
            <DateInput
                clearable
                size="md"
                label={t("Start Date")}
                value={startDate}
                onChange={setStartDate}
                maxDate={endDate}
            />
            <Space w="xl"></Space>
            <DateInput
                clearable
                size="md"
                label={t("End Date")}
                value={endDate}
                onChange={setEndDate}
                minDate={startDate}
            />
            <Space w="xl"></Space>
            <Button size="md" disabled={disabled} style={{marginTop: "24px"}}
                    onClick={preview}>{t("Preview")}</Button>
            <PreviewModal size="100%" isOpen={opened} onClose={close}
                          data={previewData}></PreviewModal>
            <Space w="xl"></Space>
            <Button size="md" color="red" disabled={disabled} style={{marginTop: "24px"}}
                    onClick={exportToCSV}>{t("Export to CSV")}</Button>
        </Flex>
        <Space h="md"/>
        {disabled ? <Text style={{color: "red"}}>❗{t("select-two-dates-message")}</Text> :
            <Fragment></Fragment>}
        <Space h="sm"/>
        <Alert>{t("no-date-message")}</Alert>
    </Drawer>)}
    </div>)


}
